// Potential future usage
export const SUPPORTED_LOCALES = [
  "en-US",
  "af-ZA",
  "ar-SA",
  "ca-ES",
  "cs-CZ",
  "da-DK",
  "de-DE",
  "el-GR",
  "es-ES",
  "fi-FI",
  "fr-FR",
  "he-IL",
  "hu-HU",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "nl-NL",
  "no-NO",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "sr-SP",
  "sv-SE",
  "sw-TZ",
  "tr-TR",
  "uk-UA",
  "vi-VN",
  "zh-CN",
  "zh-TW",
];
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number] | "pseudo";

export const DEFAULT_LOCALE: SupportedLocale = "en-US";
